import { KrCard } from '@/common/card/KrCard';
import { FilterContainer } from '@/common/dashboard/FilterContainer';
import { Form } from '@/common/form/Form';
import { FormFields } from '@/common/form/rendering/FormFields';
import { useNavStateSync } from '@/common/hooks/navState/useNavStateSync';
import { ContentBox } from '@/common/layout/ContentBox';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Title } from '@/common/title/Title';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useEffect, useState } from 'react';
import { DirSaleGrossNetTrendChart } from './DirSaleGrossNetTrendChart';
import { DirSaleGrowthCards } from './DirSaleGrowthCards';
import { DirSaleLineTopCtrtCard } from './DirSaleLineTopCtrtCard';
import { DirSaleValChart } from './DirSaleValChart';

export const DirSaleDashboard = () => {
  const rsrc = useRsrc();

  const { navState } = useNavState();

  const [fieldDefs, setFieldDefs] = useState();
  const [periods, setPeriods] = useState();
  const [totalProdIds, setTotalProdIds] = useState();
  const [formValues, setFormValues] = useNavStateSync('formValues');

  // Defaulted here rather than in the effect so the first run and the run after the defaults land agree on it
  const periodicity = formValues?.periodicity ?? 'QUARTER';

  useEffect(() => {
    rsrc.data('sc', 'DIR_SALE_DASHBOARD_FILTERS_DATA_PLUGIN', { periodicity }).then((res) => {
      setFieldDefs([
        { field: 'invPeriodId', displayName: 'Invoice Period', type: 'DROPDOWN', values: res.periods },
        {
          field: 'periodicity',
          displayName: 'Periodicity',
          type: 'DROPDOWN',
          values: [
            { value: 'MONTH', displayName: 'Month' },
            { value: 'QUARTER', displayName: 'Quarter' },
          ],
        },
        { field: 'prodIds', displayName: 'Products', type: 'TREE', treeData: res.prodTreeData },
      ]);

      setTotalProdIds(res.prodIds);
      setPeriods(res.periods);

      if (!navState.formValues || !res.periods.map((p) => p.value).includes(formValues.invPeriodId)) {
        setFormValues({
          invPeriodId: res.periods[0].value,
          periodicity,
          prodIds: formValues?.prodIds ?? res.prodIds,
        });
      }
    });
  }, [periodicity]);

  if (!fieldDefs || !totalProdIds) {
    return;
  }

  const periodCode = periods?.find((period) => period.value === formValues?.invPeriodId)?.displayName;

  return (
    <ContentBox>
      <Title icon={fas.faTasks} title="Direct Sale Dashboard" />

      {/* Filters */}
      <Form formValues={formValues} setFormValues={setFormValues}>
        <FormFields fieldDefs={fieldDefs} container={FilterContainer} />
      </Form>

      <SpacerLayout>
        <Spacer vertical weights={[1, 1]}>
          <Spacer weights={[2, 3]}>
            <KrCard title="Validation Status">
              <DirSaleValChart formValues={formValues} totalProdIds={totalProdIds} periodCode={periodCode} />
            </KrCard>
            <DirSaleLineTopCtrtCard formValues={formValues} totalProdIds={totalProdIds} />
          </Spacer>
          <Spacer weights={[1, 3]}>
            <DirSaleGrowthCards formValues={formValues} totalProdIds={totalProdIds} />
            <KrCard title="Gross vs Net Sales">
              <DirSaleGrossNetTrendChart formValues={formValues} totalProdIds={totalProdIds} />
            </KrCard>
          </Spacer>
        </Spacer>
      </SpacerLayout>
    </ContentBox>
  );
};
